import axios from 'axios';
import { API_PATH } from 'config';
import { getAccessTokenApi } from 'api/auth';

const auth = () => ({ headers: { Authorization: getAccessTokenApi() } });

export const listArchivedDocs = async (tipo, entidadId) => {
  const { data } = await axios.get(`${API_PATH}/documentos-archivados`, {
    params: { tipo, entidadId },
    ...auth(),
  });
  return data.rows || [];
};

export const getArchivedDocDownloadUrl = async (id) => {
  const { data } = await axios.get(`${API_PATH}/documentos-archivados/${id}/download`, auth());
  return data.url;
};
